import { Suspense, lazy } from 'react';
import { Route, Navigate } from 'react-router-dom';
import SuspenseFallback from '../Layout/AppMain/SuspenseFallback';
import ProtectedRoute from '../components/ProtectedRoute';
import GuestRoute from '../components/GuestRoute';
import { isAuthenticated } from '../auth/session';

// Every demo section is code-split so only the routes a user visits pay the
// bundle cost. When you're starting a new project, delete this file (and the
// entire `DemoPages/` folder) and pass your own `<Route>` children into
// `<AppMain>` from your own routes module.

const UserPages = lazy(() => import('./UserPages'));
const Login = lazy(() => import('./UserPages/Login/'));
const LoginBoxed = lazy(() => import('./UserPages/LoginBoxed/'));
const Register = lazy(() => import('./UserPages/Register/'));
const RegisterBoxed = lazy(() => import('./UserPages/RegisterBoxed/'));
const ForgotPassword = lazy(() => import('./UserPages/ForgotPassword/'));
const ForgotPasswordBoxed = lazy(() => import('./UserPages/ForgotPasswordBoxed/'));
const Applications = lazy(() => import('./Applications'));
const Dashboards = lazy(() => import('./Dashboards'));
const Widgets = lazy(() => import('./Widgets'));
const Elements = lazy(() => import('./Elements'));
const Components = lazy(() => import('./Components'));
const Charts = lazy(() => import('./Charts'));
const Forms = lazy(() => import('./Forms'));
const Tables = lazy(() => import('./Tables'));
const PlanningAssessment = lazy(() => import('./PlanningAssessment'));

const lazyRoute = (Component, type = 'ball-pulse-rise') => (
  <Suspense fallback={<SuspenseFallback type={type} />}>
    <Component />
  </Suspense>
);

const guestRoute = (Component, type = 'line-scale-party') => (
  <GuestRoute>{lazyRoute(Component, type)}</GuestRoute>
);

const protectedRoute = (Component, type = 'ball-pulse-rise') => (
  <ProtectedRoute>{lazyRoute(Component, type)}</ProtectedRoute>
);

export default function demoRoutes() {
  return (
    <>
      <Route path="/login" element={guestRoute(Login)} />
      <Route path="/login-boxed" element={guestRoute(LoginBoxed)} />
      <Route path="/register" element={guestRoute(Register)} />
      <Route path="/register-boxed" element={guestRoute(RegisterBoxed)} />
      <Route path="/forgot-password" element={guestRoute(ForgotPassword)} />
      <Route
        path="/forgot-password-boxed"
        element={guestRoute(ForgotPasswordBoxed)}
      />
      <Route path="/auth/login" element={guestRoute(Login)} />
      <Route path="/auth/register" element={guestRoute(Register)} />
      <Route path="/auth/forgot-password" element={guestRoute(ForgotPassword)} />
      <Route path="/components/*" element={protectedRoute(Components)} />
      <Route path="/forms/*" element={protectedRoute(Forms)} />
      <Route path="/charts/*" element={protectedRoute(Charts, 'ball-rotate')} />
      <Route path="/tables/*" element={protectedRoute(Tables)} />
      <Route
        path="/planning-assessement/*"
        element={protectedRoute(PlanningAssessment, 'ball-scale-ripple')}
      />
      <Route path="/elements/*" element={protectedRoute(Elements, 'line-scale')} />
      <Route path="/widgets/*" element={protectedRoute(Widgets, 'ball-pulse-sync')} />
      <Route path="/pages/*" element={protectedRoute(UserPages, 'line-scale-party')} />
      <Route path="/apps/*" element={protectedRoute(Applications, 'ball-pulse')} />
      <Route path="/dashboards/*" element={protectedRoute(Dashboards, 'ball-grid-cy')} />
      <Route
        path="/"
        element={<Navigate to={isAuthenticated() ? '/dashboards/crm' : '/login'} replace />}
      />
    </>
  );
}
